import { get } from 'utils/axios';
import { GetListingV3PublicResponseSchema } from '@kouto/types';
import z from 'zod';

type GetListingV3Response = z.infer<typeof GetListingV3PublicResponseSchema>;

const getListingV3 = async (url: string) => {
  const response = await get<{ data: GetListingV3Response }>(url);
  return response.data;
};

export default getListingV3;
